
import { reactive, toRefs } from "vue";
export default {
  name: "HeadTitle",
  props: {
    title: String,
  },
  setup() {
    const data = reactive({});
    return {
      ...toRefs(data),
    };
  },
};
